export default "__VITE_ASSET__b8af9621__"